module.exports = __webpack_public_path__ + "static/media/lose.4a620f0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/lose.mp3
// module id = 3lXY
// module chunks = 1